// API configuration
export const API_BASE_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';

// Helper function to create full API URLs
export const createApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};